import type { Article, ProfileData } from '../data/profileData';

export interface ContentStats {
  articles: number;
  certifications: number;
  books: number;
}

/** Counts shown in the hero credibility strip, derived from the content so they never go stale. */
export const getContentStats = (data: ProfileData): ContentStats => ({
  articles: data.publications.articles.length,
  certifications: data.certifications.length,
  books: data.books.books.length,
});

/** The most recently dated article (dates are ISO yyyy-mm-dd), or undefined when there are none. */
export const getFeaturedArticle = (articles: Article[]): Article | undefined =>
  articles.reduce<Article | undefined>(
    (latest, article) => (!latest || article.date > latest.date ? article : latest),
    undefined
  );
